import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { GTMService } from '@services';
import { GatewayDevice, GatewayStore, RemoteDeviceDetails, RemoteDeviceType } from '@store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DEVICES_TO_COMMISSIONING_IN_VICARE_THERMOSTAT_MODE } from '../../../single-room-control/src-overlay/commissioning/commissioning.model';
import { CommissioningService } from '../../../single-room-control/src-overlay/commissioning/commissioning.service';

@Component({
  selector: 'app-vicare-thermostat-overlay',
  templateUrl: './vicare-thermostat-overlay.component.html',
  styleUrls: ['./vicare-thermostat-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VicareThermostatOverlayComponent implements OnInit, OnDestroy {
  climateSensor: GatewayDevice;
  remoteControllers: RemoteDeviceDetails[];
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public gatewayStore: GatewayStore,
    private commissioningService: CommissioningService,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.gatewayStore.climateSensorDevice$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((dev: GatewayDevice) => {
        this.climateSensor = dev;
      });

    this.gatewayStore.getVitotrolDevices$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((devs: RemoteDeviceDetails[]) => {
        this.remoteControllers = devs;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onAddComponent(): void {
    this.initDevicesToCommissioning();
    this.commissioningService.openAddDeviceDialog();
  }

  deleteDevice(device: GatewayDevice): void {
    this.commissioningService.deleteDevice(device);
    this.gtmService.track('deleteDevice');
  }

  onDeleteComponentCancel(): void {
    this.gtmService.track('onCancel', 'Delete device', 'commissioning');
  }

  private initDevicesToCommissioning(): void {
    //Disable the device type
    const devicesToCommissioning =
      this.climateSensor || this.remoteControllers?.length
        ? DEVICES_TO_COMMISSIONING_IN_VICARE_THERMOSTAT_MODE.filter(
            (value) =>
              value.type !== RemoteDeviceType.CS && value.type !== RemoteDeviceType.VITOTROL_100E
          )
        : DEVICES_TO_COMMISSIONING_IN_VICARE_THERMOSTAT_MODE;

    this.commissioningService.devicesToCommissioning$.next(devicesToCommissioning);
  }

  deleteVitotrol(event: GatewayDevice): void {
    if (event) {
      this.deleteDevice(event);
    } else {
      this.onDeleteComponentCancel();
    }
  }
}
